import React, { useState, useContext } from "react";
import {
  MenuList,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AutorenewIcon from "@mui/icons-material/Autorenew";
// import { VscDebugContinue } from "react-icons/vsc";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { IoMdEye } from "react-icons/io";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
//Import from project
import Status from "./Status";
import AssignClassToStudentForm from "../AssignClassToStudentForm";
import DialogDelete from "../../../../Utils/DialogDelete";
import { AuthContext } from "../../../../Context/AuthContext";
import ContinueStudy from "./ContinueStudy";
import { DELETE_STUDENT_ENROLLMENT } from "../../../../Schema/Class";

export default function ClassAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  // console.log("editData::", editData);

  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => {
    setOpenEdit(true);
    handleClose();
  };
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openStatus, setOpenStatus] = useState(false);
  const handleOpenStatus = () => {
    setOpenStatus(true);
    handleClose();
  };
  const handleCloseStatus = () => setOpenStatus(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => {
    setOpenDel(true);
    handleClose();
  };
  const handleCloseDel = () => setOpenDel(false);

  //Modal update hour
  const [openUpdateHour, setOpenUpdateHour] = useState(false);
  const handleOpenUpdateHour = () => {
    setOpenUpdateHour(true);
    handleClose();
  };
  const handleCloseUpdateHour = () => setOpenUpdateHour(false);

  const [deleteStudentEnrollment] = useMutation(DELETE_STUDENT_ENROLLMENT, {
    onCompleted: ({ deleteStudentEnrollment }) => {
      // console.log("deleteStudentEnrollment :", deleteStudentEnrollment);
      setLoading(false);
      if (deleteStudentEnrollment?.isSuccess === true) {
        setAlert(true, "success", deleteStudentEnrollment?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteStudentEnrollment?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteStudentEnrollment({
      variables: {
        id: editData?._id,
      },
    });
  };

  // console.log("editData::", editData);

  return (
    <div>
      <IconButton onClick={handleClick}>
        <MoreVertIcon sx={{ color: "#131870" }} fontSize="small" />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuList>
          <MenuItem
            onClick={() =>
              navigate(
                `/student/student-detail/student-class-detail?classId=${editData?.classId?._id}&studentId=${editData?.studentId?._id}`,
              )
            }
          >
            <ListItemIcon>
              <IoMdEye style={{ color: "#131870" }} fontSize="20px" />
            </ListItemIcon>
            <ListItemText>{t("view")}</ListItemText>
          </MenuItem>

          {editData?.status !== "studying" && (
            <MenuItem onClick={handleOpenUpdateHour}>
              <ListItemIcon>
                <SkipNextIcon fontSize="small" sx={{ color: "green" }} />
              </ListItemIcon>
              <ListItemText>{t("continue_study")}</ListItemText>
            </MenuItem>
          )}

          <MenuItem onClick={handleOpenStatus}>
            <ListItemIcon>
              <AutorenewIcon fontSize="small" sx={{ color: "green" }} />
            </ListItemIcon>
            <ListItemText>{t("status")}</ListItemText>
          </MenuItem>

          <MenuItem onClick={handleOpenEdit}>
            <ListItemIcon>
              <EditIcon fontSize="small" sx={{ color: "orange" }} />
            </ListItemIcon>
            <ListItemText>{t("update")}</ListItemText>
          </MenuItem>

          <MenuItem onClick={handleOpenDel}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" sx={{ color: "red" }} />
            </ListItemIcon>
            <ListItemText>{t("delete")}</ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>

      {openUpdateHour && (
        <ContinueStudy
          open={openUpdateHour}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseUpdateHour}
        />
      )}

      {openEdit && (
        <AssignClassToStudentForm
          open={openEdit}
          dialogTitle={"Update"}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}

      {openStatus && (
        <Status
          open={openStatus}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseStatus}
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_Student_enrollment")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
